
import { Component, ModelSync, Prop, Vue } from 'vue-property-decorator'
import CancelButton from '../buttons/CancelButton.vue'
import EditButton from '../buttons/EditButton.vue'
import EditFrame from '../EditFrame.vue'

@Component({
  components: {
    EditFrame,
    CancelButton,
    EditButton
  }
})
export default class InfoDialog extends Vue {
  @ModelSync('value', 'input')
  show!: boolean

  @Prop({ default: 'Information' })
  title!: string

  @Prop({ default: 'Okay' })
  infoActionText!: string

  @Prop({ default: false })
  hideCancel!: boolean

  onCancel () {
    this.show = false
    this.$emit('cancel')
  }

  onConfirm () {
    this.show = false
    this.$emit('confirm')
  }
}
